import React, { Component } from 'react';
import PropTypes from "prop-types";



class CurrencyCellRender extends Component {

  render() {
    return Number(this.props.value).toFixed(2);
  }
}

CurrencyCellRender.propTypes = {
  value: PropTypes.any,
};

export default CurrencyCellRender;